<script setup lang="ts">
import MainBreadcrumbs from "../../../ui/components/header/MainBreadcrumbs.vue";
import { useI18n } from "vue-i18n";
import { computed, onBeforeMount, ref, Ref } from "vue";
import { useBaseStore } from "@/stores/base";
import { RouteGuards } from "@/router/guards";
import Card from "@/ui/components/cards/Card.vue";
import { AUTH_MODULES } from "@/ui/Enums";
const { t } = useI18n();
const store = useBaseStore();

const breadcrumbs = [
	{
		title: "Profile",
		disabled: true,
		to: "/profile",
	},
];

type tabsType = {
	itemId: string;
	translationKey: string;
	icon: string;
	to: string;
};

const tabs: Ref<tabsType[]> = ref([
	{
		itemId: "general-settings",
		translationKey: "users.detail.generalTab",
		icon: "fa-user-astronaut",
		to: `/profile/${store.currentUser.uuid}/general-settings`,
	},
	{
		itemId: "color-palettes",
		translationKey: "users.detail.colorPalettesTab",
		icon: "fa-palette",
		to: `/profile/${store.currentUser.uuid}/color-palettes`,
	},
]);

onBeforeMount(() => {
	const environmentRequires2FAbutUserHasNo2FA =
		!useBaseStore().currentUser.has2FA &&
		useBaseStore().currentEnvironment.is_two_factor_authentication_required &&
		useBaseStore().currentUser.authentication_module ===
			AUTH_MODULES.MOTIVES_NATIVE;

	if (!environmentRequires2FAbutUserHasNo2FA) {
		tabs.value.push({
			itemId: "notification-events",
			translationKey: "users.detail.notificationsTab",
			icon: "fa-bell-on",
			to: `/profile/${store.currentUser.uuid}/notification-events`,
		});
		tabs.value.push({
			itemId: "notification-settings",
			translationKey: "users.detail.notificationPreferenceTab",
			icon: "fa-list-check",
			to: `/profile/${store.currentUser.uuid}/notification-settings`,
		});
	}
});

const activeTab = ref(null);
</script>

<template>
	<main-breadcrumbs :breadcrumbs="breadcrumbs" is-user />

	<v-tabs v-model="activeTab">
		<v-tab
			v-for="tab in tabs"
			:key="tab.itemId"
			v-show="
				RouteGuards.hasPermissions({
					to: RouteGuards.getRouteByPath(tab.to),
					store,
				})
			"
			:value="tab.itemId"
			color="primary"
			:to="tab.to"
		>
			<i :class="`fa-duotone ${tab.icon} fa-lg`"></i>
			<div class="tab-text">
				{{ $t(tab.translationKey) }}
			</div>
		</v-tab>
	</v-tabs>
	<v-divider />
	<router-view />
</template>

<style scoped></style>
